export const normalizeSearchText = (value) => {
  if (!value) return '';
  const map = {
    ı: 'i',
    İ: 'i',
    ş: 's',
    Ş: 's',
    ğ: 'g',
    Ğ: 'g',
    ü: 'u',
    Ü: 'u',
    ö: 'o',
    Ö: 'o',
    ç: 'c',
    Ç: 'c',
  };
  return value
    .split('')
    .map((char) => map[char] ?? char)
    .join('')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

export const tokenizeSearchText = (value) => {
  if (!value) return [];
  return normalizeSearchText(value)
    .split(/[^a-z0-9]+/g)
    .filter(Boolean);
};
